import { makeActionCreator } from 'utils/reduxUtils/reduxUtils';
import keymirror from 'keymirror';

export const types = keymirror({
  REQUEST_MADE: null,
  REQUEST_SUCCESS: null,
  REQUEST_ERROR: null,
  REQUEST_RETRY: null,
});

export default {
  requestMade: makeActionCreator(types.REQUEST_MADE, 'requestName'),
  requestSuccess: makeActionCreator(types.REQUEST_SUCCESS, 'requestName'),
  requestError: makeActionCreator(types.REQUEST_ERROR, 'requestName'),
  requestRetry: makeActionCreator(types.REQUEST_RETRY, 'requestName'),
};



// WEBPACK FOOTER //
// ./actions/httpActions/httpActions.js